import { Component, forwardRef, Input } from "@angular/core";
import { FormsModule, NG_VALUE_ACCESSOR } from "@angular/forms";
import { BaseFieldComponent } from "./base-field.component";

let counter = 0;

// TODO: Handle missing label property. Move label out of ng-content.
@Component({
  selector: "mr-checkbox",
  template: `
    <div>
      <input
        #checkbox
        type="checkbox"
        [disabled]="isDisabled"
        [attr.aria-label]="isLabelHidden ? label : null"
        [attr.aria-labelledby]="isLabelHidden ? null : labelId"
        [ngModel]="checked"
        (ngModelChange)="propagateChange($event)"
        (change)="$event.stopPropagation()"
        (blur)="onBlur()"
      />
      <label
        [attr.title]="isLabelHidden ? label : null"
        (click)="checkbox.click()"
        [id]="labelId"
      >
        @if (!isLabelHidden) {
          @if (label) {
            {{ label }}
          } @else {
            <ng-content></ng-content>
          }
          @if (description) {
            <span class="description">{{ description }}</span>
          }
        }
      </label>
    </div>
  `,
  styleUrls: ["checkbox.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => CheckboxComponent),
    },
  ],
  imports: [FormsModule],
})
export class CheckboxComponent extends BaseFieldComponent<boolean> {
  @Input() public get checked(): boolean {
    return this.value ?? false;
  }
  public set checked(value: boolean) {
    this.value = value;
  }

  private readonly index = counter++;

  public readonly labelId = `mr-checkbox-field-label-${this.index}`;
}
